import Tabs from '../../../assets/js/modules/_tabs.js';

function MemberCenter() {
	const node = document.querySelector('.member-center');

	if ( ! node ) {
		return;
	}

	if ( ! node ) {
		return;
	}

	new Tabs( node, {
		contentsActiveClass: 'member-center__tab--active',
		contentsClass      : 'member-center__tab',
		interactiveClass   : 'member-center--interactive',
		navClass           : 'member-center__tabs-nav',
		navItemClass       : 'member-center__tabs-nav-item',
		navItemActiveClass : 'member-center__tabs-nav-item--active',
		navLinkClass       : 'member-center__tabs-nav-link',
	} );

	const tabsNavToggle = node.querySelector('.member-center__tab-nav-toggle');
	const tabsNavLabel  = tabsNavToggle.querySelector('span');
	const tabsNav       = node.querySelector('.member-center__tabs-nav');
	const menuToggle    = node.querySelector('.member-center__menu-toggle');
	const menu          = node.querySelector('.member-center__menu');

	tabsNavToggle.addEventListener('click', () => {
		tabsNavToggle.classList.toggle('member-center__tab-nav-toggle--open');
		tabsNav.classList.toggle('member-center__tabs-nav--visible')
	} );

	menuToggle.addEventListener('click', () => {
		menuToggle.classList.toggle('member-center__menu-toggle--open');
		menu.classList.toggle('member-center__menu--visible');
	} );

	node.addEventListener('tabs:change', () => {
		const active = node.querySelector('.member-center__tabs-nav-item--active');

		if ( active ) {
			tabsNavLabel.innerText = active.innerText;
		}
	} );
}

export default MemberCenter();
